import { useProduct, eur, eur2 } from "@/lib/product";

export const PPC_NOTE = "Prix public conseillé (PPC) : prix de vente conseillé du produit, donné à titre indicatif.";

export const PriceBlock = ({ prefix, size = "lg", note = false }) => {
  const { product } = useProduct();
  if (!product) return <div className="h-16 w-56 rounded-xl bg-slate-200/70 animate-pulse" />;
  const big = size === "lg" ? "text-5xl sm:text-6xl" : "text-4xl sm:text-5xl";
  return (
    <div className="flex flex-col gap-1">
      {product.promo_active && (
        <span data-testid={`${prefix}-ppc-label`} title={PPC_NOTE} className="text-sm text-slate-500">
          Prix public conseillé{note ? "*" : ""} :{" "}
          <s data-testid={`${prefix}-old-price`} className="text-slate-400 decoration-orange-500/80 decoration-2 font-medium">{eur(product.normal_price)}</s>
        </span>
      )}
      <div className="flex items-end gap-3 flex-wrap">
        <span data-testid={`${prefix}-current-price`} className={`font-display font-extrabold tracking-tight text-slate-900 leading-none ${big}`}>
          {eur(product.current_price)}
        </span>
        <span className="text-sm font-semibold text-slate-500 pb-1">TTC</span>
        {product.promo_active && (
          <span data-testid={`${prefix}-savings-badge`} className="savings-pill">
            −{eur(product.normal_price - product.promo_price)} vs PPC
          </span>
        )}
      </div>
      <span data-testid={`${prefix}-shipping-fee`} className="text-sm text-slate-500">
        + livraison {eur(product.shipping_fee)}
      </span>
      {product.klarna_enabled && (
        <span data-testid={`${prefix}-klarna`} className="text-sm text-slate-600 mt-1">
          ou payez en 3x ou 4x avec <strong className="text-slate-900">Klarna</strong> : 3 × {eur2(product.klarna_3x)} ou 4 × {eur2(product.klarna_4x)} <span className="text-slate-500">(livraison incluse)</span>
          <span className="block text-xs text-slate-400">Sous réserve d'acceptation par Klarna, selon les conditions Klarna.</span>
        </span>
      )}
      {note && product.promo_active && <span data-testid="ppc-footnote" className="text-xs text-slate-400 mt-1">* {PPC_NOTE}</span>}
    </div>
  );
};
